module.exports = __webpack_public_path__ + "img/100_dice[8].724d87ad.png";